import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0923da38&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/github-markdown-light.css?vue&type=style&index=0&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=0923da38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0923da38",
  null
  
)

export default component.exports